import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import * as plugins from '../plugins'
import type { TypeParams } from '../types'

/**
 * Reloads the current space record whenever functional usage is successfully
 * updated. This ensures the record history log reflects the latest changes.
 */
export const reloadOnFunctionalUsageChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins
      .lookup(plugins.functionalUsage.Plugin)
      .get()
      .feature.actions.applyUpdates.success.observe()
      .pipe(
        rxjs.withLatestFrom(
          collection.plugins.currentEntityPlugin.feature.selectors.getEntity()
            .asObservable,
        ),
        rxjs.map(([_action, entity]) => {
          if (!entity) {
            return store.effects.SKIP
          }

          return collection.plugins.currentEntityPlugin.feature.actions.getEntity
            .from('(effect) reload record on functional usage change')
            .create({})
        }),
      ),
)
